import { Controller } from "@hotwired/stimulus"

export default class ParallaxController extends Controller {
  static targets = ["bg"]
  static values = { speed: { type: Number, default: 0.3 } }

  declare readonly bgTargets: HTMLElement[]
  declare readonly hasBgTarget: boolean
  declare readonly speedValue: number

  private scrollHandler!: () => void

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this.scrollHandler = this.onScroll.bind(this)
    window.addEventListener("scroll", this.scrollHandler, { passive: true })
  }

  disconnect() {
    window.removeEventListener("scroll", this.scrollHandler)
  }

  private onScroll() {
    const rect = this.element.getBoundingClientRect()

    if (this.hasBgTarget) {
      this.bgTargets.forEach((el) => {
        const speed = parseFloat(el.dataset["parallaxSpeedValue"] ?? String(this.speedValue))
        el.style.transform = `translateY(${-rect.top * speed}px)`
      })
    }
  }
}
